import { isValid, parseISO } from 'date-fns';
import { Amount } from '../../model';
import { Importo } from '../generated';

const defaultDateTo = new Date();
const defaultDateFrom = new Date();
defaultDateFrom.setFullYear(defaultDateFrom.getFullYear() - 1);

export const parseServerDateTime = (dateString: string): Date =>
  parseISO(dateString ?? '');

export const parseServerShortDate = (dateString: string): Date =>
  parseServerDateTime(`${dateString ?? ''}T00:00:00.000Z`);

export const formatDateFromForServer = (date: Date) =>
  isValid(date) ? date.toISOString() : defaultDateFrom.toISOString();

export const formatDateToForServer = (date: Date) => {
  const validDate = isValid(date) ? date : defaultDateTo;
  const parsedDate = new Date(validDate.getTime() + 24 * 60 * 60 * 1000 - 1);
  return parsedDate.toISOString();
};

export const parseServerAmount = (amount: Importo): Amount => ({
  value: amount?.valore ?? -1,
  currency: ['', undefined, 'E'].includes(amount?.divisa)
    ? 'EUR'
    : amount?.divisa,
});

export const parsePhoneNumberForServer = (phoneNumber: string) =>
  phoneNumber.replaceAll(' ', '');

export const parseDateToDatestring = (date: Date) =>
  isValid(date)
    ? `${date.getFullYear()}-${String(date.getMonth() + 1).padStart(
        2,
        '0'
      )}-${String(date.getDate()).padStart(2, '0')}`
    : undefined;
